// widgets/QuickLinks.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Boxes, Car, Warehouse, BadgeDollarSign, ListChecks, ScanLine, Truck, PlusCircle, BarChart3, Shield } from 'lucide-react';
import '../App.css';
import './Widgets.css';

const links = [
  { to: '/inventory', label: 'Inventory', icon: Boxes },
  { to: '/demo', label: 'Demo Fleet', icon: Car },
  { to: '/stock', label: 'Stock', icon: Warehouse },
  { to: '/rentals', label: 'Rentals', icon: BadgeDollarSign },
  { to: '/sold', label: 'Sold', icon: ListChecks },
  { to: '/vin', label: 'Scan VIN', icon: ScanLine },
  { to: '/pdi', label: 'Start PDI', icon: ListChecks },
  { to: '/driver', label: 'Driver', icon: Truck },
  { to: '/new', label: 'Add Record', icon: PlusCircle },
  { to: '/reports', label: 'Reports', icon: BarChart3 },
  { to: '/admin', label: 'Admin', icon: Shield },
];

export default function QuickLinks() {
  const nav = useNavigate();

  return (
    <div className="widget quick-links">
      <h3 className="widget-title">Quick Links</h3>
      <div className="links-grid">
        {links.map(({ to, label, icon: Icon }) => (
          <button key={to} className="link-item" onClick={() => nav(to)}>
            <Icon size={20} />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
